import { ProgCss } from "../ProgCss.Generated";
import { createAndShowAlert, createAndShowConfirm } from "../app";
import { castOrNull, cast } from "../tools";
import { vertaal } from "../vertaal";

export function registerDocentCijferLijstFormListener(scopeEl : HTMLElement) {
    const docent_cijfer_invoer_form = castOrNull(scopeEl.querySelector("#docent_cijfer_invoer_form"), HTMLFormElement);
    if (docent_cijfer_invoer_form == null) {
        return;
    }

    const knopongedaan = cast(docent_cijfer_invoer_form.querySelector("#knopongedaan"), HTMLElement);
    knopongedaan.addEventListener("click", () => doreset(docent_cijfer_invoer_form));

    setCheckDocentCijfer(docent_cijfer_invoer_form);
}

function doreset(form: HTMLFormElement) {
    form.reset();

    const idStudentToevoegen = castOrNull(document.querySelector('#idStudentToevoegen'), HTMLElement);
    idStudentToevoegen?.classList.remove(ProgCss.is_disabled);

    const idDocentWijzig = cast(document.querySelector('#idDocentWijzig'), HTMLElement);
    idDocentWijzig.classList.remove(ProgCss.is_disabled);

    const idDocentTerug = cast(document.querySelector('#idDocentTerug'), HTMLElement);
    idDocentTerug.classList.remove(ProgCss.is_disabled);

    const idDocentTerugOverzicht = cast(document.querySelector('#idDocentTerugOverzicht'), HTMLElement);
    idDocentTerugOverzicht?.classList.remove(ProgCss.is_disabled);

    const idStudentKlembord = castOrNull(document.querySelector('#idStudentKlembord'), HTMLElement);
    idStudentKlembord?.classList.remove(ProgCss.is_disabled);

    const knopongedaan = cast(form.querySelector('#knopongedaan'), HTMLElement);
    knopongedaan.classList.add(ProgCss.is_disabled);

    for (const element of form.querySelectorAll(`.${ProgCss.ibgc}`)) {
        element.classList.remove(ProgCss.ibgc);
    }
}

export function registerDocentDocentFormListener(scopeEl : HTMLElement) {

    const docent_cijferlijst_definitief_form = castOrNull(scopeEl.querySelector("#docent_cijferlijst_definitief_form"), HTMLFormElement);
    docent_cijferlijst_definitief_form?.addEventListener("submit",
        function (e) {
            /*volgende pagina zet iets in dit window*/
            open('about:blank', 'P3Wprint', 'toolbar=yes,resizable=yes,scrollbars=yes,status=0,width=600,height=400');
        })

    const cijferlijstPrintTrigger = castOrNull(scopeEl.querySelector("#cijferlijstPrintTrigger"), HTMLSpanElement);
    if (cijferlijstPrintTrigger) {
        const p3wPrint = open(cijferlijstPrintTrigger.getAttribute("data-printurl")!, 'P3Wprint', 'toolbar=yes,resizable=yes,scrollbars=yes,status=0,width=600,height=400');
        p3wPrint?.focus();
    }

    const docent_docent_studentselecteer_form = castOrNull(scopeEl.querySelector("#docent_docent_studentselecteer_form"), HTMLFormElement);
    if (docent_docent_studentselecteer_form != null) {
        const studentToevoegenOpslaan = docent_docent_studentselecteer_form.querySelector("#studentToevoegenOpslaan");
        studentToevoegenOpslaan?.addEventListener("click", () => checkCijferSubmit(docent_docent_studentselecteer_form));
        docent_docent_studentselecteer_form.addEventListener("submit",
            function (e) {
                const focusInputs = Array.from(docent_docent_studentselecteer_form.getElementsByClassName(ProgCss.js_select_docent_cijfer_check));
                if (focusInputs && focusInputs.length == 1) { //moet 1 input zijn
                    if (!chk(docent_docent_studentselecteer_form, cast(focusInputs[0], HTMLInputElement), false)) {
                        e.preventDefault();
                    }
                }

            }
        )
        const cijferInput = cast(Array.from(docent_docent_studentselecteer_form.getElementsByClassName(ProgCss.js_select_docent_cijfer_check))[0], HTMLInputElement);
        cijferInput?.addEventListener("keydown", e => {
            if (e.key == "Enter") {
                e.preventDefault();
                checkCijferSubmit(docent_docent_studentselecteer_form);
            }
        })
    }
}

function checkCijferSubmit(form: HTMLFormElement) {
    //TODO: dit is gewoon form validatie, maar ouderwetse opzet zit ons nog niet accuut in de weg
    const focusInputs = Array.from(document.getElementsByClassName(ProgCss.js_select_docent_cijfer_check));
    if (focusInputs.every(el => chk(form, cast(el, HTMLInputElement), false))) {
        form.requestSubmit(); // TODO: als we hier ooit form validation voor gebruiken mag dit vast weg
    }
}

function setCheckDocentCijfer(form: HTMLFormElement) {
    for (const item of document.getElementsByClassName(ProgCss.js_select_docent_cijfer_check)) {
        cast(item, HTMLElement).addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                e.preventDefault(); 
            }
        });
        item.addEventListener("change", () => chk(form, cast(item, HTMLInputElement), true));
    }
}

function chk(form: HTMLFormElement, element: HTMLInputElement, oncijferlijstEnChanged: boolean) {
    const resRegExp = new RegExp(form.getAttribute("data-meetlatregex")!);
    const docentmetdecimaal = form.getAttribute("data-docentmetdecimaal")!.toLowerCase() == "true";
    const docentbevestig10 = form.getAttribute("data-docentbevestig10")!.toLowerCase() == "true";
    const foutmelding = form.getAttribute("data-foutmelding")!;

    if (oncijferlijstEnChanged) {
        document.getElementById('idStudentToevoegen')?.classList.add(ProgCss.is_disabled);
        document.getElementById('idStudentKlembord')?.classList.add(ProgCss.is_disabled);
        document.getElementById('idDocentWijzig')?.classList.add(ProgCss.is_disabled);
        document.getElementById('idDocentTerug')?.classList.add(ProgCss.is_disabled);
        document.getElementById('idDocentTerugOverzicht')?.classList.add(ProgCss.is_disabled);
        document.getElementById('knopongedaan')?.classList.remove(ProgCss.is_disabled);
        element.classList.add(ProgCss.ibgc);
    }
    let tststr = element.value;
    tststr = tststr.replace(/\,/, ".");
    tststr = tststr.replace(" ", "");

    if (docentbevestig10) {
        if (tststr == "10") {
            if (oncijferlijstEnChanged) {
                if (element.value != element.defaultValue) {
                    createAndShowConfirm(
                        "Opmerking",
                        "U heeft een 10 ingevuld; Bedoelt u een 10.0 kies dan Bevestigen/Confirm, bedoelt u een 1.0 kies dan Annuleren/Cancel",
                        () => {
                            if (docentmetdecimaal) {
                                tststr = "10.0";
                            } else {
                                tststr = "10";
                            }

                            return onContinue();
                        },
                        () => {
                            tststr = "1.0";

                            return onContinue();
                        }
                    );
                }
            }
        }
    }

    return onContinue();

    function onContinue(): boolean {
        const tstflt = parseFloat(tststr);

        if (!isNaN(tstflt)) {
            if (tstflt > 10 && tststr.length > 1 && tststr != "10") {
                tststr = tststr.charAt(0) + "." + tststr.charAt(1);
            }
        }

        if (docentmetdecimaal) {
            if (tststr.length == 1 && (!isNaN(tstflt))) {
                tststr = tststr + '.0';
            }
            if (tststr.length == 2 && tststr.charAt(1) == '.') {
                tststr = tststr + '0';
            }
            if (tststr != "10" && tststr.length == 2 && tststr.charAt(1) == '0') {
                tststr = tststr.charAt(0) + '.0';
            }
        } else {
            tststr = tststr.replace(/\.0/, "");
        }

        /*09 -> 0.9*/
        if (tststr.charAt(0) == "0" && tststr.length == 2) {
            tststr = tststr.charAt(0) + "." + tststr.charAt(1);
        }
        /*.9 -> 0.9*/
        if (tststr.charAt(0) == ".") {
            tststr = '0' + tststr;
        }

        tststr = tststr.toUpperCase();

        element.value = tststr;

        if (resRegExp.exec(tststr)) {
            return true;
        }
        else {
            createAndShowAlert(vertaal("Ongeldige beoordeling", "Invalid rating"), tststr + vertaal(" is geen geldige invoer", " is not a valid mark") + ';\n' + foutmelding, () => {
                element.value = "";
                element.focus();
            });
            return false;
        }
    }
}
